import { InputProps, TooltipProps } from "@chakra-ui/react";
import { FormField } from "@models/form";
import { Translation } from "@models/language";
import {
  FieldPath,
  FieldPathValue,
  FieldValues,
  Validate,
} from "react-hook-form";

export enum TooltipIcon {
  Info = "info",
  Warning = "warning",
}

export interface UIFormField extends FormField {
  // react-hook-form props
  validate?:
    | Validate<FieldPathValue<FieldValues, FieldPath<FieldValues>>, FieldValues>
    | Record<
        string,
        Validate<
          FieldPathValue<FieldValues, FieldPath<FieldValues>>,
          FieldValues
        >
      >;
  // chakra-ui props
  tooltipProps?: TooltipProps;
  inputProps?: InputProps;
  icon?: any;
  leftAddon?: string; // https://chakra-ui.com/docs/components/input/usage#left-and-right-addons
  leftAddonWidth?: string; // percent value. ie: "50%"" . Default: "auto"
  leftAddonHeight?: string; // rem value ie: "3rem" . Default: "auto"
  rightAddon?: string;

  // custom props
  tooltipIcon?: TooltipIcon;
  groupLabel?: Translation;

  // For mouse enter component detection
  updateCurrentEventPreviewPart?: (fieldKey: string) => void;
}

export interface ImageUploadFormField extends UIFormField {
  dimension?: {
    width: number;
    height: number;
  };
  container?: {
    width: number;
    height: number;
  };
  defaultImage?: string;
  maxSize?: number; // in MB

  // callback function to be called after file is uploaded
  onSuccess?: (url: string) => void;
  onDelete?: () => void;
  onStartUploading?: () => void;
  onEndUploading?: () => void;
}

export type Field = UIFormField | ImageUploadFormField;
